export const searchThemesFromTrendsCharts = {
    yAxisUnitOfBusinessAmount: '(百万米ドル)',
    yAxisUnit: '(10億円)'
}
